import { TableDefine } from '@/libs/tableHelper/type'
import { MeritsList } from '@/api/merits/MeritsList'
import { ModalStatus } from '@/libs/formHelper/modalForm/type'
import { PhoneUser } from '@/mock/api/demoUser'
import { Donation } from '@/api/donation/Donation'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<MeritsList> {
  const tableCols = [
    {
      title: '项目名称',
      width: 300,
      render: (h: any, params: any) => {
        return h('div', params.row.donation.name)
      }
    },
    {
      title: '捐赠人',
      key: 'genealogyMember',
      type: {
        module: 'jsonKey',
        jsonKey: 'name'
      }
    },
    {
      title: '捐赠人手机号',
      key: 'genealogyMember',
      type: {
        module: 'jsonKey',
        jsonKey: 'phone'
      }
    },
    {
      title: '捐赠金额',
      key: 'money'
    },
    {
      title: '捐赠时间',
      type: {
        module: 'time',
        format: 'yyyy-MM-DD'
      },
      key: 'donationTime',
      width: 200
    }
  ]

  const actions: any = [
    {
      name: 'edit',
      title: '编辑',
      onClick: (item: MeritsList) => {
        view.onEditItem(item)
      }
    },
    {
      key: 'del',
      title: '删除',
      type: 'submit',
      button: 'error',
      actionClose: true,
      modal: {
        message: '确定要删除吗？'
      },
      onClick: (item: MeritsList) => {
        return view.onDelItem(item)
      }
    }
  ]

  return {
    tableCols,
    actions
  }
}
